import * as React from 'react';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { Bem } from '../../utils/css.js';
import '../../constants.js';
import { Icon } from '../Icon/Icon.js';
import './NavigationLogo.scss.js';

const { element, block } = Bem.create("vai-navigation-logo");
const NavigationLogo = ({ open }) => /* @__PURE__ */ React.createElement("div", {
  className: block()
}, /* @__PURE__ */ React.createElement("div", {
  className: element("container")(open ? "open" : "closed")
}, /* @__PURE__ */ React.createElement("div", {
  className: element("content")()
}, /* @__PURE__ */ React.createElement(Icon, {
  name: VaiIcon.VaisalaLogoLarge
}))));

export { NavigationLogo };
